import { render, staticRenderFns } from "./option-list.vue?vue&type=template&id=bc5740a0&scoped=true"
import script from "./option-list.vue?vue&type=script&lang=js"
export * from "./option-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5740a0",
  null
  
)

export default component.exports